"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExposedClasses = void 0;
/**
 * helper function to generate data attributes for exposed classes
 */
const getExposedClasses = (name, classes, exposedClasses) => {
  const classMap = {};
  exposedClasses.forEach(exposedClass => {
    if (classes[exposedClass]) {
      classMap[exposedClass] = classes[exposedClass].split(' ');
    }
  });
  return {
    'data-dstype': name,
    'data-dsclassmap': JSON.stringify(classMap)
  };
};
exports.getExposedClasses = getExposedClasses;